module.exports = __webpack_public_path__ + "static/quality-website@3x-3cb6fdab2f32a3eca8c17ee252d45646.png";